/**
 * @file: equals.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { dateFromValue } from '@euler/utils/datetime';

export const equals = <T>(a: T | null | undefined, b: T | null | undefined) => {
  if (a == null) {
    return b == null;
  }
  if (b == null) {
    return a == null;
  }
  return a === b;
};

export const dateValueEquals = (
  a: string | Date | null | undefined,
  b: string | Date | null | undefined,
) => {
  if (!equals(a, b)) return false;
  return equals(dateFromValue(a), dateFromValue(b));
};
